import { useAllSettlements } from "../../hooks/settlements/useAllSettlements";
import DataTable from "../DataTables/DataTable";
import { Link } from "react-router-dom";
import { formatToDate } from "../configs/formatToDate";
import StatusBadge from "../assests/StatusBadge";
import { message, Tooltip } from "antd";
import { Clipboard } from "react-feather";
function SettlementTable() {
  const query = `status=requested&limit=5`;
  const { data, isLoading } = useAllSettlements(query);
  console.log("Data ", data);

  const sortedData = data?.sort((a, b) => {
    const dateA = new Date(a?.request_date).getTime(); // Convert to milliseconds
    const dateB = new Date(b?.request_date).getTime(); // Convert to milliseconds
    return dateB - dateA;
  });
  console.log("Sorted data ", sortedData);

  // const columns = [
  //     {
  //       title: "Initiated by",
  //       dataIndex: "",
  //       render: (item, record) => (
  //         <div className="d-flex align-items-center">
  //           {record?.user?.first_name || "N/A"}
  //         </div>
  //       ),
  //       // sorter: (a, b) => a.patientname.length - b.patientname.length,
  //     },
  //     {
  //       title: "Amount",
  //       dataIndex: "amount",
  //       render: (item) => <div>{item || "N/A"}</div>,
  //       // sorter: (a, b) => a.patientname.length - b.patientname.length,
  //     },
  //     {
  //       title: <div className="text-center">Payment mode</div>,
  //       dataIndex: "payment_type",
  //       // sorter: (a, b) => a.type.length - b.type.length,
  //       render: (item) => (
  //         <div className="text-center">{item ? item : "unknown"}</div>
  //       ),
  //     },
  //     {
  //       title: "Request Date",
  //       dataIndex: "request_date",
  //       // sorter: (a, b) => a.time.length - b.time.length,
  //       render: (item) => <div>{formatToDate(item)}</div>,
  //       sorter: (a, b) => new Date(a.updated_at) - new Date(b.updated_at),
  //       sortDirections: ["descend", "ascend"],
  //     },
  //     {
  //       title: <div className="text-center">Status</div>,
  //       dataIndex: "status",
  //       // sorter: (a, b) => a.status.length - b.status.length,
  //       render: (item) => (
  //         <div className="d-flex justify-content-center">
  //           <StatusBadge status={item} />
  //         </div>
  //       ),
  //     },
  //   ];

  const columns = [
    {
      title: "TRANSACTION ID",
      dataIndex: "transaction_id",
      // sorter: (a, b) => a.bookingid.length - b.bookingid.length,
      render: (text) =>
        text ? (
          <div className="d-flex align-items-center gap-2">
            <span
              style={{
                maxWidth: 120,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={text}
            >
              {text?.slice(0, 16)}...
            </span>
            <Tooltip title="Copy Order ID">
              <Clipboard
                size={16}
                style={{ cursor: "pointer", color: "#347D73" }}
                onClick={() => {
                  navigator.clipboard.writeText(text);
                  message.success("Copied to clipboard");
                }}
              />
            </Tooltip>
          </div>
        ) : (
          <div>N/A</div>
        ),
    },
    {
      title: "INITATED BY",
      dataIndex: "",
      render: (item, record) => (
        <div className="d-flex align-items-center">
          {record?.user?.first_name || "N/A"}
        </div>
      ),
      // sorter: (a, b) => a.patientname.length - b.patientname.length,
    },
    {
      title: <div className="text-center">Payment Method</div>,
      dataIndex: "payment_method",
      // sorter: (a, b) => a.type.length - b.type.length,
      render: (item) => (
        <div className="text-center">{item ? item : "unknown"}</div>
      ),
    },
    {
      title: "AMOUNT",
      dataIndex: "amount",
      render: (item) => <div>₹{item}</div>,
      sorter: (a, b) => a.amount - b.amount,
      // render: (item) => <div>₹ {item}</div>,
    },
    {
      title: "SETTLEMENT DATE",
      dataIndex: "updated_at",
      // sorter: (a, b) => a.time.length - b.time.length,
      render: (item) => <div>{formatToDate(item)}</div>,
      sorter: (a, b) => new Date(a.updated_at) - new Date(b.updated_at),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "STATUS",
      dataIndex: "status",
      // filters: [
      //   { text: "completed", value: "completed" },
      //   { text: "pending", value: "pending" },
      // ],
      // onFilter: (value, record) => record.status.startsWith(value),
      // filterSearch: true,
      render: (item) => (
        <div>
          <StatusBadge status={item} />
        </div>
      ),
    },
  ];
  return (
    <div className="card-box">
      <div className="d-flex justify-content-between pb-2">
        <h4>Recent Settlemet Requests</h4>
        <Link to="/dashboard/settlement-requests">See all</Link>
      </div>
      <DataTable
        columns={columns}
        data={sortedData ?? []}
        isLoading={isLoading}
      />
    </div>
  );
}

export default SettlementTable;
